import { IAcuerdo, IAcuerdoSeleccionado } from "./acuerdos";
import { INuevaEntrada } from "./entradas";

export interface IIndicacionAB {
  indicacion: string;
  idTema: string;
  usuario: string;
  fechaIndicacion: string;
  idIndicacion?: string;
}

export const StateIndicacionAB = {
  indicacion: "",
  idTema: "",
  usuario: "",
  fechaIndicacion: "",
};

export interface IDetalleTema {
  idAcuerdo?: string;
  id: string;
  categorizacion: string;
  tipoTema: number;
  edoTema: number;
  indiceTema: number;
  nombreTema: string;
  descripcionTema: string;
  descripcionTema_html: string;
  esConfidencial: number;
  esAprobado: number;
  esImpreso: number;
  respAnalista: string;
  respSupervisor: string;
  respCoordinador: string;
  justificacion: null;
  id_categoria: number;
  fechaAcuerdo: string;
  entradas: INuevaEntrada[];
  indicacionesAB: IIndicacionAB[];
  expanded?: boolean | false;
  nuevoTema?: boolean | false;
  //campos adocioonales para nuevo tema
  nombreUsuario?: string;
  nombreAnalista?: string;
  nombreSupervisor?: string;
  nombreCoordinador?: string;
  id_categorizacion?: string;
}

export const IStateAcuerdoSeleccionado: IAcuerdoSeleccionado = {
  acuerdo: {
    esRealizado: false,
    fechaAcuerdo: "",
    idFE: "",
    observaciones: "", // La observaciones es opcional
    temas: 0,
    urlUnico: false,
    expanded: false,
  },
  temas: [],
  archivos: [],
  status: "",
  statusTema: "",
  ultimoTemaGuardado: null,
};

export const stateDetalleTema = {
  id: "",
  idAcuerdo: "",
  categorizacion: "",
  tipoTema: 0,
  edoTema: 0,
  indiceTema: 0,
  nombreTema: "",
  descripcionTema: "",
  descripcionTema_html: "",
  esConfidencial: 0,
  esAprobado: 0,
  esImpreso: 0,
  respAnalista: "",
  respSupervisor: "",
  respCoordinador: "",
  justificacion: null,
  id_categoria: 0,
  fechaAcuerdo: "",
  entradas: [],
  indicacionesAB: [],
  expanded: false,
  nuevoTema: false,
};
